module.exports = __webpack_public_path__ + "img/itx-file-type-gif.4d145d27.svg";